import { Text } from "../../../../atoms/Text";
import { cn } from "../../../../lib/cn";
import { paletteText } from "./palette";

interface KindTagProps {
  children: React.ReactNode;
  /** Palette path; defaults to the quiet caption colour. */
  color?: string;
}

/** Unboxed caption after a title ("Not booked"). Quiet by design. */
export const KindTag = ({ children, color = "text.secondary" }: KindTagProps) => (
  <Text
    as="span"
    variant="inherit"
    className={cn(
      "shrink-0 whitespace-nowrap text-(length:--ledger-text-cell) leading-[1.66]",
      paletteText(color),
    )}
    style={paletteText(color) === undefined ? { color } : undefined}
  >
    {children}
  </Text>
);
